var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonToolbar',{attrs:{"search":"","color":"#d16400","active":_vm.active,"types":_vm.body_types},on:{"update":_vm.updateToolbar}})
}
var staticRenderFns = []

export { render, staticRenderFns }